import type {RankingMetric} from '../../../../core/repositories/columnRepository';

export const RANKING_METRIC_MAP = {
  daily_pv: '日間',
  weekly_pv: '週間',
  monthly_pv: '月間',
} satisfies Record<RankingMetric, string>;

export const RANKING_METRIC_OPTIONS = Object.entries(RANKING_METRIC_MAP).map(
  ([key, value]) => ({
    value: key as RankingMetric,
    label: value,
  }),
);
